// All UI copy lives here so it is easy to edit later.
// SR (Serbian, latinica) is the source of truth and reproduced exactly.
// Bold is marked with **double asterisks** and rendered by the RichText helper.

export const translations = {
  sr: {
    langSwitchFlags: "🇮🇹🇬🇧",
    tagline:
      "Digitalni preduzetnik, kreator digitalnih projekata i osnivač NAŠA Community. Čovek koji spaja ljude, ideje i vizije.",
    menu: {
      about: "Više o meni...",
      hub: "Pristupi NAŠA HUB-u",
      contact: "Saradnja / Kontakt",
      langSwitch: "Izbor jezika 👈",
    },
    vision: {
      heading: "Moja vizija",
      italic:
        "Verujem da svako može da kreira svoj put - ako ima znanje, pravu strategiju i dovoljno hrabrosti da se pokrene.",
      checks: [
        "Verujem u ljude i njihove potencijale",
        "Verujem u pokret i napredak",
        "Verujem u viziju koja menja život",
      ],
    },
    gate: {
      intro: "Unesi svoju email adresu da dobiješ pristup NAŠA HUB-u.",
      exitIntro: "Napuštaš milosh-nikolic.com i prelaziš na NAŠA HUB — centralni portal cele zajednice.",
      exitConfirm: "Razumem da napuštam ovaj sajt i otvaram NAŠA HUB.",
      exitGo: "Nastavi na NAŠA HUB →",
      placeholder: "tvoj@email.com",
      submit: "Potvrdi",
      successTitle: "Uspešno! Dobio si pristup.",
      open: "Otvori NAŠA HUB →",
      invalid: "Unesi ispravnu email adresu.",
      sending: "Slanje...",
    },
    about: {
      pageTitle: "O meni",
      intro1:
        "Rođen sam u Beogradu, odrastao sam na severu Italije i ceo život proveo između različitih kultura, gradova i ljudi. To me je naučilo da razumem svet, ljude i promene — i da od svakog mesta napravim novi početak.",
      intro2: [
        "Preduzetništvo nije bio moj cilj.",
        "Bio je **instinkt**.",
        "Potraga da stvorim nešto svoje i da spojim ljude oko vrednosti, ideja i vizije.",
      ],
      path: {
        heading: "Moj Put",
        p1: "Odrastao sam u internacionalnom okruženju i vrlo rano ušao u svet digitalnog preduzetništva.",
        p2: "Radio sam u različitim industrijama, gradio timove, zajednice i projekte, i kroz vreme formirao svoj pristup poslu:",
        bold: "jasna vizija + efikasna strategija + stabilna realizacija.",
        p3: "Danas radim sa ljudima iz različitih zemalja i fokusiram se na projekte koji imaju dugoročnu vrednost i održivost.",
      },
      today: {
        heading: "Šta radim danas",
        intro: "Danas gradim i vodim više digitalnih projekata:",
        bullets: [
          "**NAŠA Community** – zajednica ljudi iz Ex-Yu i dijaspore",
          "**Digitalni projekti i sistemi**",
          "**Blockchain & Web3 edukacije**",
          "**Online sistemi za rast, monetizaciju i zajednice**",
          "**Branding i digitalna strategija**",
        ],
        closing: [
          "Ne prodajem snove.",
          "Ne obećavam brze rezultate.",
          "Verujem u rad, strategiju i saradnju.",
        ],
      },
      values: {
        heading: "Vrednosti koje vodim kroz posao",
        bullets: [
          "Profesionalnost",
          "Jasna komunikacija",
          "Doslednost",
          "Vizija i strateško razmišljanje",
          "Prava konekcija i saradnja",
        ],
      },
      mission: {
        heading: "Moja Misija",
        text: "Moja misija je jednostavna: **da spojim ljude, ideje i mogućnosti** i da pokažem da svako može da kreira svoj put — ako ima znanje, pravu strategiju i hrabrost da krene.",
      },
      personal: {
        heading: "Lična Strana",
        p1: [
          "U poslu verujem u snagu zajednice.",
          "U životu verujem u iskrenost i prijateljske odnose.",
        ],
        p2: "Verujem da ono što gradimo — u poslu i privatno — ima smisla samo ako u to unesemo **srce, lojalnost i karakter**.",
      },
      nav: {
        hub: "Pristupi NAŠA HUB-u",
        contact: "Saradnja / Kontakt",
        back: "Nazad 👈",
      },
    },
    contact: {
      heading: "Saradnja / Kontakt",
      invite:
        "Otvoren sam za saradnju, partnerstva i nove ideje. Piši mi i javljam se uskoro.",
      write: "Piši mi →",
      instagram: "Instagram",
      back: "Nazad 👈",
    },
  },

  it: {
    langSwitchFlags: "🇷🇸🇬🇧",
    tagline:
      "Imprenditore digitale, creatore di progetti digitali e fondatore di NAŠA Community. Un uomo che unisce persone, idee e visioni.",
    menu: {
      about: "Di più su di me...",
      hub: "Accedi a NAŠA HUB",
      contact: "Collaborazione / Contatto",
      langSwitch: "Scelta della lingua 👈",
    },
    vision: {
      heading: "La mia visione",
      italic:
        "Credo che ognuno possa creare il proprio percorso - se ha conoscenza, la strategia giusta e abbastanza coraggio per mettersi in moto.",
      checks: [
        "Credo nelle persone e nel loro potenziale",
        "Credo nel movimento e nel progresso",
        "Credo in una visione che cambia la vita",
      ],
    },
    gate: {
      intro: "Inserisci il tuo indirizzo email per ottenere l'accesso a NAŠA HUB.",
      exitIntro: "Stai lasciando milosh-nikolic.com e passi a NAŠA HUB — il portale centrale dell'intera community.",
      exitConfirm: "Capisco che sto lasciando questo sito e apro NAŠA HUB.",
      exitGo: "Continua su NAŠA HUB →",
      placeholder: "tua@email.com",
      submit: "Conferma",
      successTitle: "Fatto! Hai ottenuto l'accesso.",
      open: "Apri NAŠA HUB →",
      invalid: "Inserisci un indirizzo email valido.",
      sending: "Invio...",
    },
    about: {
      pageTitle: "Su di me",
      intro1:
        "Sono nato a Belgrado, sono cresciuto nel nord Italia e ho passato tutta la vita tra culture, città e persone diverse. Questo mi ha insegnato a capire il mondo, le persone e i cambiamenti — e a fare di ogni luogo un nuovo inizio.",
      intro2: [
        "L'imprenditoria non era il mio obiettivo.",
        "Era un **istinto**.",
        "La ricerca di creare qualcosa di mio e di unire le persone attorno a valori, idee e visione.",
      ],
      path: {
        heading: "Il mio percorso",
        p1: "Sono cresciuto in un ambiente internazionale e sono entrato molto presto nel mondo dell'imprenditoria digitale.",
        p2: "Ho lavorato in settori diversi, ho costruito team, comunità e progetti, e col tempo ho formato il mio approccio al lavoro:",
        bold: "visione chiara + strategia efficace + realizzazione stabile.",
        p3: "Oggi lavoro con persone di paesi diversi e mi concentro su progetti che hanno valore a lungo termine e sostenibilità.",
      },
      today: {
        heading: "Cosa faccio oggi",
        intro: "Oggi costruisco e guido diversi progetti digitali:",
        bullets: [
          "**NAŠA Community** – una comunità di persone dell'Ex-Yu e della diaspora",
          "**Progetti e sistemi digitali**",
          "**Formazione Blockchain & Web3**",
          "**Sistemi online per crescita, monetizzazione e comunità**",
          "**Branding e strategia digitale**",
        ],
        closing: [
          "Non vendo sogni.",
          "Non prometto risultati rapidi.",
          "Credo nel lavoro, nella strategia e nella collaborazione.",
        ],
      },
      values: {
        heading: "I valori che guidano il mio lavoro",
        bullets: [
          "Professionalità",
          "Comunicazione chiara",
          "Coerenza",
          "Visione e pensiero strategico",
          "Connessione autentica e collaborazione",
        ],
      },
      mission: {
        heading: "La mia missione",
        text: "La mia missione è semplice: **unire persone, idee e possibilità** e dimostrare che ognuno può creare il proprio percorso — se ha conoscenza, la strategia giusta e il coraggio di partire.",
      },
      personal: {
        heading: "Il lato personale",
        p1: [
          "Nel lavoro credo nella forza della comunità.",
          "Nella vita credo nella sincerità e nei rapporti di amicizia.",
        ],
        p2: "Credo che ciò che costruiamo — nel lavoro e nel privato — abbia senso solo se ci mettiamo **cuore, lealtà e carattere**.",
      },
      nav: {
        hub: "Accedi a NAŠA HUB",
        contact: "Collaborazione / Contatto",
        back: "Indietro 👈",
      },
    },
    contact: {
      heading: "Collaborazione / Contatto",
      invite:
        "Sono aperto a collaborazioni, partnership e nuove idee. Scrivimi e ti risponderò presto.",
      write: "Scrivimi →",
      instagram: "Instagram",
      back: "Indietro 👈",
    },
  },

  en: {
    langSwitchFlags: "🇷🇸🇮🇹",
    tagline:
      "Digital entrepreneur, creator of digital projects and founder of NAŠA Community. A man who connects people, ideas and visions.",
    menu: {
      about: "More about me...",
      hub: "Access NAŠA HUB",
      contact: "Collaboration / Contact",
      langSwitch: "Language selection 👈",
    },
    vision: {
      heading: "My vision",
      italic:
        "I believe that everyone can create their own path - if they have knowledge, the right strategy and enough courage to get moving.",
      checks: [
        "I believe in people and their potential",
        "I believe in movement and progress",
        "I believe in a vision that changes lives",
      ],
    },
    gate: {
      intro: "Enter your email address to get access to NAŠA HUB.",
      exitIntro: "You are leaving milosh-nikolic.com and heading to NAŠA HUB — the central portal of the whole community.",
      exitConfirm: "I understand I am leaving this site and opening NAŠA HUB.",
      exitGo: "Continue to NAŠA HUB →",
      placeholder: "you@email.com",
      submit: "Confirm",
      successTitle: "Success! You now have access.",
      open: "Open NAŠA HUB →",
      invalid: "Please enter a valid email address.",
      sending: "Sending...",
    },
    about: {
      pageTitle: "About me",
      intro1:
        "I was born in Belgrade, grew up in northern Italy and spent my whole life between different cultures, cities and people. That taught me to understand the world, people and change — and to make a new beginning out of every place.",
      intro2: [
        "Entrepreneurship was not my goal.",
        "It was an **instinct**.",
        "A search to create something of my own and to connect people around values, ideas and vision.",
      ],
      path: {
        heading: "My Journey",
        p1: "I grew up in an international environment and entered the world of digital entrepreneurship very early.",
        p2: "I worked in different industries, built teams, communities and projects, and over time formed my approach to work:",
        bold: "clear vision + effective strategy + stable execution.",
        p3: "Today I work with people from different countries and focus on projects that have long-term value and sustainability.",
      },
      today: {
        heading: "What I do today",
        intro: "Today I build and lead several digital projects:",
        bullets: [
          "**NAŠA Community** – a community of people from Ex-Yu and the diaspora",
          "**Digital projects and systems**",
          "**Blockchain & Web3 education**",
          "**Online systems for growth, monetization and communities**",
          "**Branding and digital strategy**",
        ],
        closing: [
          "I don't sell dreams.",
          "I don't promise quick results.",
          "I believe in work, strategy and collaboration.",
        ],
      },
      values: {
        heading: "The values that guide my work",
        bullets: [
          "Professionalism",
          "Clear communication",
          "Consistency",
          "Vision and strategic thinking",
          "Real connection and collaboration",
        ],
      },
      mission: {
        heading: "My Mission",
        text: "My mission is simple: **to connect people, ideas and opportunities** and to show that everyone can create their own path — if they have knowledge, the right strategy and the courage to start.",
      },
      personal: {
        heading: "The Personal Side",
        p1: [
          "In business I believe in the strength of community.",
          "In life I believe in honesty and friendly relationships.",
        ],
        p2: "I believe that what we build — in business and privately — only makes sense if we put **heart, loyalty and character** into it.",
      },
      nav: {
        hub: "Access NAŠA HUB",
        contact: "Collaboration / Contact",
        back: "Back 👈",
      },
    },
    contact: {
      heading: "Collaboration / Contact",
      invite:
        "I'm open to collaboration, partnerships and new ideas. Write to me and I'll get back to you soon.",
      write: "Write to me →",
      instagram: "Instagram",
      back: "Back 👈",
    },
  },
};

export const getT = (lang) => translations[lang] || translations.sr;
